import { emailValidate } from "./emailValidation";

// The license column is the key that tells the backend which license the row
// updates: it comes from the export and must not be touched
export const CSV_HEADER = [
  "teams_power_email",
  "microsoft_teams_email",
  "license",
];
export const CSV_SAMPLE_SIZE = 5;
// A discarded line is shown as it is in the file, cut if too long
export const CSV_LINE_MAX_LENGTH = 120;

// Parse the licenses import CSV
// Only counters and the first discarded lines are kept, so a very large file
// does not end up in the store nor in the preview
// -> {
//      validCount: rows with at least one email, they update a license
//      unlinkCount: rows with both emails empty, they unlink the license
//      invalidCount, sampleErrors: [{ line, reason, text }],
//      headerError: true if the header does not match CSV_HEADER,
//      empty: true if there is no data row
//    }
export function parseLicensesCsv(text, sampleSize = CSV_SAMPLE_SIZE) {
  const lines = String(text)
    .replace(/^﻿/, "")
    .split(/\r?\n/);

  const header = (lines[0] || "")
    .split(";")
    .map((value) => value.trim().toLowerCase());

  if (
    header.length !== CSV_HEADER.length ||
    header.some((value, index) => value !== CSV_HEADER[index])
  ) {
    return {
      validCount: 0,
      unlinkCount: 0,
      invalidCount: 0,
      sampleErrors: [],
      headerError: true,
      empty: false,
    };
  }

  let validCount = 0;
  let unlinkCount = 0;
  let invalidCount = 0;
  let sampleErrors = [];
  let licenses = new Set();

  const fncError = (lineNumber, reason, line) => {
    invalidCount++;
    if (sampleErrors.length < sampleSize) {
      sampleErrors.push({
        line: lineNumber,
        reason: reason,
        text:
          line.length > CSV_LINE_MAX_LENGTH
            ? line.slice(0, CSV_LINE_MAX_LENGTH) + "…"
            : line,
      });
    }
  };

  for (let index = 1; index < lines.length; index++) {
    const line = lines[index].trim();
    const lineNumber = index + 1;

    if (line.length < 1) {
      continue;
    }

    const cells = line.split(";").map((value) => value.trim());

    if (cells.length !== CSV_HEADER.length) {
      fncError(lineNumber, "Columns", line);
      continue;
    }

    const email = cells[0];
    const microsoftEmail = cells[1];
    const license = cells[2];

    // The key must be there and must appear once
    if (license.length < 1) {
      fncError(lineNumber, "LicenseEmpty", line);
      continue;
    }
    if (licenses.has(license)) {
      fncError(lineNumber, "LicenseDuplicated", line);
      continue;
    }
    licenses.add(license);

    // Both emails empty: the license gets unlinked
    if (email.length < 1 && microsoftEmail.length < 1) {
      unlinkCount++;
      continue;
    }

    // An email can be left empty, but if it is there it has to be valid
    if (
      (email.length > 0 && !emailValidate(email)) ||
      (microsoftEmail.length > 0 && !emailValidate(microsoftEmail))
    ) {
      fncError(lineNumber, "MailNotValid", line);
      continue;
    }

    validCount++;
  }

  return {
    validCount: validCount,
    unlinkCount: unlinkCount,
    invalidCount: invalidCount,
    sampleErrors: sampleErrors,
    headerError: false,
    empty: validCount < 1 && unlinkCount < 1 && invalidCount < 1,
  };
}
